<template>
  <v-container class="pt-4">
    <v-row>
      <v-col :cols="12">
        <v-row no-gutters>
          <v-col cols="12" class="d-flex justify-center">
            <v-chip color="warning"> เริ่มต้น </v-chip>
          </v-col>
          <v-col cols="12">
            <WorkflowAction
              v-for="(action, index) in value"
              :key="index"
              :value="action"
              :actions="value"
              :types="types"
              @action-select="actionSelect"
            />
            <NewActionDialog
              v-if="value.length == 0 || !value[value.length - 1].childAction1"
              :actions="value"
              :types="types"
              class="d-flex justify-center"
            >
              <template v-slot:activator="{ on }">
                <v-btn text color="primary" @click="on">
                  <v-icon>mdi-plus</v-icon> เพิ่ม
                </v-btn>
              </template>
            </NewActionDialog>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card
      v-if="showProp"
      class="form-designer-prop-window"
      elevation="10"
      :width="propWidth"
    >
      <v-toolbar dense flat>
        <v-toolbar-title v-if="activeAction">{{
          activeAction.actionType
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="propWidth == '400px'"
          icon
          small
          @click="propWidth = '1000px'"
        >
          <v-icon>mdi-arrow-expand</v-icon>
        </v-btn>
        <v-btn
          v-if="propWidth == '1000px'"
          icon
          small
          @click="propWidth = '400px'"
        >
          <v-icon>mdi-arrow-collapse</v-icon>
        </v-btn>
        <v-btn icon small @click="showProp = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text v-if="activeAction == null">
        <v-icon class="mr-2">mdi-information-outline</v-icon>
        <span>Please select any action to edit.</span>
      </v-card-text>
      <v-toolbar dense flat v-else>
        <v-btn icon small title="Move Up" @click="moveActionUp">
          <v-icon small>mdi-arrow-up</v-icon>
        </v-btn>
        <v-btn icon small title="Move Down" @click="moveActionDown">
          <v-icon small>mdi-arrow-down</v-icon>
        </v-btn>
        <v-btn icon small color="error" title="Delete" @click="deleteAction">
          <v-icon small>mdi-delete-outline</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider v-if="activeAction != null"></v-divider>
      <div class="prop-container">
        <slot v-if="activeAction != null"></slot>
      </div>
    </v-card>
    <v-btn
      v-else
      fab
      color="primary"
      class="form-designer-prop-button"
      @click="showProp = true"
      title="Edit Action"
    >
      <v-icon>mdi-square-edit-outline</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import WorkflowAction from "./WorkflowAction.vue";
import NewActionDialog from "./NewActionDialog.vue";

export default {
  components: {
    WorkflowAction,
    NewActionDialog,
  },

  props: ["value", "types"],

  data() {
    return {
      activeAction: null,
      activeActions: null,
      showProp: false,
      propWidth: "400px",
    };
  },

  methods: {
    deleteAction() {
      if (confirm("คุณต้องการลบแอคชันที่เลือกใช่หรือไม่?")) {
        var idx = this.activeActions.indexOf(this.activeAction);
        this.activeActions.splice(idx, 1);
        this.activeAction = null;
      }
    },
    moveActionUp() {
      var idx = this.activeActions.indexOf(this.activeAction);

      if (idx > 0) {
        var row1 = this.activeActions[idx];
        var row2 = this.activeActions[idx - 1];
        this.activeActions.splice(idx - 1, 2, row1, row2);
      }
    },
    moveActionDown() {
      var idx = this.activeActions.indexOf(this.activeAction);

      if (idx < this.activeActions.length - 1) {
        var row1 = this.activeActions[idx + 1];
        var row2 = this.activeActions[idx];
        this.activeActions.splice(idx, 2, row1, row2);
      }
    },
    actionSelect(params) {
      this.activeAction = params.selection;
      this.activeActions = params.actions;
      this.showProp = true;
      this.$emit("action-select", params);
    },
    getType(name) {
      for (let i = 0; i < this.types.length; i++) {
        for (let j = 0; j < this.types[i].types.length; j++) {
          const t = this.types[i].types[j];
          if (name == t.name) {
            return t;
          }
        }
      }

      return null;
    },
  },
};
</script>

<style>
.form-designer-prop-window {
  position: fixed;
  right: 30px;
  top: 80px;
  width: 600px;
}

.form-designer-prop-window .prop-container {
  position: relative;
  height: 500px;
  overflow-y: auto;
}

.form-designer-prop-button {
  position: fixed;
  right: 30px;
  top: 80px;
}
</style>